module.exports = __webpack_public_path__ + "static/img/img-vision1.1f20a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-vision1.png
// module id = 951Q
// module chunks = 36